export const SIGN_IN_WITH_PROVIDER = 'Sign in with {PROVIDER}';
export const SYNCING_ACCOUNT = 'Syncing Account';
export const ENTER_AUTHENTICATOR_CODE =
  'Enter your PullRequest code from Google Authenticator';
export const TWO_FACTOR_AUTHENTICATION = 'Two-Factor Authentication';
export const VERIFY = 'Verify';

export const LoginText = {
  SIGN_IN_WITH_PROVIDER,
  SYNCING_ACCOUNT,
  ENTER_AUTHENTICATOR_CODE,
  TWO_FACTOR_AUTHENTICATION,
  VERIFY,
};
